import $ from "jquery";

const $doc = $(document);
const $mobileNav = $(".js-mobile-nav");
const $hamburger = $(".js-hamburger");
const $body = $("body");
const DESKTOP_BREAKPOINT = 1024;

const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

function getFocusable() {
  return $mobileNav.find(FOCUSABLE).filter(":visible");
}

function closeNav() {
  $mobileNav.removeClass("is-active").attr("aria-hidden", "true");
  $hamburger.removeClass("is-active").attr("aria-expanded", "false");
  $(".js-header").removeClass("mobilenav-is-active");
  $body.css("overflow", "");
  $(".menu-item--active").removeClass("menu-item--active");
  $(".sub-menu-container--active").removeClass("sub-menu-container--active");
  $(".toggled-on").removeClass("toggled-on");
  // Collapse any expanded submenus so the nav reopens in its default state.
  $mobileNav.find(".menu-item.is-expanded").removeClass("is-expanded");
  $mobileNav.find(".js-submenu-toggle").attr("aria-expanded", "false");
}

function openNav() {
  $mobileNav.addClass("is-active").attr("aria-hidden", "false");
  $hamburger.addClass("is-active").attr("aria-expanded", "true");
  $(".js-header").addClass("mobilenav-is-active");
  $body.css("overflow-y", "hidden");
  // Move focus into nav for keyboard/screen reader users
  getFocusable().first().trigger("focus");
}

function showMobileNav(event) {
  event.preventDefault();
  if ($mobileNav.hasClass("is-active")) {
    closeNav();
  } else {
    openNav();
  }
}

// Trap focus within the open mobile nav
function handleKeydown(event) {
  if (!$mobileNav.hasClass("is-active")) return;

  if (event.key === "Escape") {
    closeNav();
    $hamburger.trigger("focus");
    return;
  }

  if (event.key !== "Tab") return;

  const $focusable = getFocusable();
  const $first = $focusable.first();
  const $last = $focusable.last();

  if (event.shiftKey) {
    if (document.activeElement === $first[0]) {
      event.preventDefault();
      $last.trigger("focus");
    }
  } else {
    if (document.activeElement === $last[0]) {
      event.preventDefault();
      $first.trigger("focus");
    }
  }
}

// Close if viewport crosses to desktop while nav is open
function handleResize() {
  if (window.innerWidth >= DESKTOP_BREAKPOINT && $mobileNav.hasClass("is-active")) {
    closeNav();
  }
}

// Inject a caret toggle button next to any mobile-nav button-styled menu item
// that has a submenu. The parent <a> stays a real link (clicking the text
// navigates); only the caret expands the submenu inline. ARIA wires the
// toggle to the submenu list so screen readers announce state correctly.
function initSubmenuToggles() {
  $mobileNav.find(".menu-item.button.menu-item-has-children").each(function () {
    const $li = $(this);
    if ($li.children(".js-submenu-toggle").length) return;

    const $link = $li.children("a").first();
    const $submenu = $li.children(".sub-menu").first();
    if (!$link.length || !$submenu.length) return;

    const submenuId = "nav-mobile-submenu-" + Math.random().toString(36).slice(2, 9);
    $submenu.attr("id", submenuId);

    const $toggle = $(
      '<button type="button" class="nav--mobile__submenu-toggle js-submenu-toggle" aria-expanded="false">' +
        '<span class="u-sr-only">Expand submenu for ' + $link.text().trim() + '</span>' +
        '<span class="nav--mobile__submenu-caret" aria-hidden="true"></span>' +
      "</button>"
    );
    $toggle.attr("aria-controls", submenuId);
    $link.after($toggle);
  });

  $doc.on("click", ".nav--mobile .js-submenu-toggle", function () {
    const $toggle = $(this);
    const $li = $toggle.closest(".menu-item");
    const willExpand = !$li.hasClass("is-expanded");

    // Close any open sibling submenus first.
    $li.siblings(".is-expanded")
      .removeClass("is-expanded")
      .find(".js-submenu-toggle")
      .attr("aria-expanded", "false");

    $li.toggleClass("is-expanded", willExpand);
    $toggle.attr("aria-expanded", willExpand ? "true" : "false");
  });
}

export default function initMobileNav() {
  // Set initial ARIA state
  $mobileNav.attr("aria-hidden", "true");

  initSubmenuToggles();

  $doc.on("click", ".js-hamburger", showMobileNav);
  $doc.on("keydown", handleKeydown);
  $(window).on("resize", handleResize);

  // Top-level nav links with a placeholder href shouldn't trigger navigation
  // or jump to top — they exist only as labels above their submenu.
  $doc.on("click", '.nav--mobile .menu-item > a[href="#"]', function (e) {
    e.preventDefault();
  });
}
